module.exports = __webpack_public_path__ + "img/icon1.1677a705.png";